import routerOptions0 from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}